import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/article');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('article', validationApi);

export function getArticleValidationHistoryOptions(articleId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(articleId);
}

export function getArticleValidationOptions(articleId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(articleId);
}

export function useValidateArticle(articleId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(articleId, queryClient));
}
